import {  encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class AttendenceReportStore {
  attendenceReport = [];
  salesPersonArray = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      attendenceReport: observable,
      salesPersonArray: observable,
      total: observable,
      loading: observable,
      loadData: action,
      getSalesPersonExecutive: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    salespersonId,
    fromDate,
    toDate,
  }) {
    // console.log("attendenceReport");
    var postData = {
      companyId: companyId,
      salespersonId: salespersonId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: 1,
    };

    if(config.pythonReport === 1){
      // postData.companyId=10166
          var response = await postApi.getClient('report').post("/miscellaneous_report/attendanceReport", postData);
    }else{
          const base64Input = await base64_encode(JSON.stringify(postData));
          response = await postApi.getClient().post("index.php?c=salesperson&a=attendaceReport","postData=" + base64Input);
    }
    this.attendenceReport = response?.data?.data.attendance;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async getSalesPersonExecutive({ companyId, offset, limit }) {
    console.log("attendenceReport");
    var postData = { companyId: companyId };
    var response = await postApi.getClient().get("employee/getSalesExecutive", {
        params: postData,
    });
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient("phpurl")
    //   .post(
    //     "index.php?c=salesperson&a=getSalesExecutive",
    //     "postData=" + base64Input
    //   );
    this.salesPersonArray = response?.data?.data;
    

    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
    return response?.data?.data;
  }
}

export default AttendenceReportStore;
